'use strict';
var React = require('react');
var runtimeHelper = require('../../helper/runtimeHelper');
var util = require('../../helper/util');
var VerticalScrollBar = require('./VerticalScrollBar');

var SelectComp = React.createClass({
  propTypes: {
    checkedIndex: React.PropTypes.number.isRequired,
    closeSelectList: React.PropTypes.func.isRequired,
    selectListItem: React.PropTypes.func.isRequired,
    textStyle: React.PropTypes.object.isRequired,
    boxStyle: React.PropTypes.object.isRequired,
    listStyle: React.PropTypes.object.isRequired,
    dataSet: React.PropTypes.array.isRequired,
  },

  getInitialState: function () {
    return {
      onItemIndex: this.props.checkedIndex
    };
  },

  componentDidUpdate: function () {
    this.loadEvent();
  },

  domIndexArray: null,
  componentDidMount: function () {
    this.loadEvent();
    //this.domIndexArray = util.pushToTop($('.component-SelectComp'));
  },

  domID: null,
  loadEvent: function () {
    var context = this;
    if (!document.onmouseup) {
      document.onmouseup = function (event) {
        //util.resetDomIndex(context.domIndexArray);
        context.props.closeSelectList();
        //context.domIndexArray = null;
        document.onmouseup = null;
      };
    }
  },

  componentWillUnmount: function () {
    document.onmouseup = null;
  },

  render: function () {
    var self = this;
    return (
      <div className='component-SelectComp'>
        <div style={this.props.boxStyle} className='select-item-box'>
          {this.props.dataSet.map(function (data, index) {
            var itemStyle = {
              width: this.props.width - 2,
              height: this.props.itemHeight,
              position: 'relative'
            };
            var textStyle = JSON.parse(JSON.stringify(self.props.textStyle));
            textStyle.color = '#000000';
            itemStyle.background = '#ffffff';
            if(index === self.props.checkedIndex) {
              //itemStyle.background = '#1E90FF';
              itemStyle.background = this.props.listStyle.selectedColor || '#41C7D6';
              textStyle.color = this.props.listStyle.selectedTextColor || '#000000';
            }
            return (
              <div key={index}
                   style={itemStyle}
                   className={data.linkStyle}
              >
                <div
                  id={index}
                  className='select-item-cover'
                  //onMouseOver={this.onItem}
                  onClick={this.checkItem}/>
                <label style={textStyle} className='select-item-text'>{data.text}</label>
              </div>);

          }, this)}
          {
            this.props.listStyle.verticalScrollbarShow &&
            <VerticalScrollBar
              height={this.props.boxStyle.height - 2}
              value={util.Int(this.props.listStyle.verticalScrollbarProgress)}
            />
          }
        </div>

      </div>
    )

  },

  checkItem: function (e) {
    e.stopPropagation();
    e.preventDefault();
    e.nativeEvent.stopPropagation();
    var index = parseInt($(e.target).attr('id'), 10) || 0;
    this.props.selectListItem(e, index);
  },
  onItem: function (e) {
    var index = parseInt($(e.target).attr('id'), 10);
    this.setState({onItemIndex: index});
  },
});

module.exports = SelectComp;


// WEBPACK FOOTER //
// ./src/views/common/SelectComp.jsx